export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign In"])},
        "videoCall": {
          "outbound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outgoing Video Call"])},
          "incoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incoming Video Call"])}
        },
        "outbound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound Call"])},
        "incoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incoming Call"])},
        "newCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Call"])},
        "numpad": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numpad"])},
        "endedCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Call ended"])},
        "pausedCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Call paused"])},
        "hints": {
          "buttonMinimize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Minimize"])},
          "buttonMaximize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expand"])},
          "buttonFullscreen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maximize"])},
          "buttonCollapse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Collapse"])},
          "buttonClose": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])},
          "buttonsSettings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["More actions"])}
        },
        "statuses": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose status"])},
          "banned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Banned"])},
          "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Online"])},
          "ready": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ready"])},
          "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offline"])},
          "dnd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do not disturb"])},
          "inService": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In service"])},
          "afterService": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["After service"])},
          "timeout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Timeout"])},
          "dialing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dialing"])}
        },
        "moreActionsList": {
          "settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
        }
      },
      "ru": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вход"])},
        "videoCall": {
          "outbound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Исходящий видеозвонок"])},
          "incoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Входящий видеозвонок"])}
        },
        "outbound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Исходящий вызов"])},
        "incoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Входящий вызов"])},
        "newCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новый звонок"])},
        "numpad": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Панель набора"])},
        "endedCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вызов завершен"])},
        "pausedCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вызов приостановлен"])},
        "hints": {
          "buttonMinimize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Уменьшить"])},
          "buttonMaximize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Увеличить"])},
          "buttonFullscreen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Развернуть"])},
          "buttonCollapse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Свернуть"])},
          "buttonClose": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Закрыть"])},
          "buttonsSettings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ещё"])}
        },
        "statuses": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выбрать статус"])},
          "banned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Забанен"])},
          "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Онлайн"])},
          "ready": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Готов"])},
          "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оффлайн"])},
          "dnd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не беспокоить"])},
          "inService": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["В разговоре"])},
          "afterService": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Постобработка"])},
          "timeout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перерыв"])},
          "dialing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Набор номера"])}
        },
        "moreActionsList": {
          "settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выйти"])}
        }
      }
    }
  })
}
